import { focusTrap } from '../utility/focusTrap'
import { after } from '../utility/transition'

let active = null

function openModal(modal, trigger) {
	const trap = focusTrap(modal)
	active = { modal, trigger, trap }
	modal.hidden = false
	// force reflow so the open transition runs from the closed state
	void modal.offsetWidth
	modal.classList.add('is-open')
	trap.enter()
}

function closeModal() {
	if (!active) return
	const { modal, trap } = active
	active = null
	modal.classList.remove('is-open')
	after(modal, function() {
		modal.hidden = true
		trap.exit()
	})
}

function onTriggerClick(trigger) {
	const id = trigger.getAttribute('aria-controls') || trigger.getAttribute('data-modal')
	const modal = id && document.getElementById(id)
	if (modal) openModal(modal, trigger)
}

function onKeydown(event) {
	if (event.key === 'Escape' && active) closeModal()
}

function onClick(event) {
	if (!active) return
	if (event.target.closest('.js-modal-close')) return closeModal()
	if (event.target === active.modal) closeModal()
}

document.querySelectorAll('.js-modal-trigger').forEach(function(trigger) {
	trigger.addEventListener('click', function() {
		onTriggerClick(trigger)
	})
})

document.addEventListener('keydown', onKeydown)
document.addEventListener('click', onClick)
